module.exports = __webpack_public_path__ + "static/media/tv.90db8d9d.webp";